import React, { useEffect, useState } from "react";
import { Form, Button } from "react-bootstrap";
import { notification, message } from "antd";
import { Card } from "react-bootstrap";
import axiosInstance from "../../utils/api";

const Information = () => {
  const [selected, setSelected] = useState("");
  const [apiValues, setValues] = useState({
    mainValues: [],
  });
  const [information, setInformationValues] = useState({
    serial: [],
    firmware: null,
    remark: null,
    probe: null,
    pump_a: null,
    pump_b: null,
    pump_c: null,
    pcb: null,
  });

  //call data
  useEffect(() => {
    axiosInstance.get("https://api.cl-ds.com/admin/node/information")
      .then((fetchdata) => {
        console.log(fetchdata);
        setValues({
          ...apiValues,
          mainValues: fetchdata,
        });
        console.log(apiValues);
      }).catch(err=>{
        console.log(err)
      })
  }, []);

  //Findsdata
  const selectedValue = apiValues.mainValues.find(({ serial }) => serial === selected);

  //Showing result in the view data button
  const openResult = () => {
    notification.open({
      message: "Form Data",
      duration: 0,
      description: JSON.stringify(information),
      onClick: () => {
        console.log("Button was clicked");
      },
    });
  };

  //onChange
  function onChangehandler(e) {
    setInformationValues({
      ...information,
      [e.target.name]: e.target.value,
      firmware: document.getElementById("firmware").value,
      remark: document.getElementById("remark").value,
      probe: document.getElementById("probe").value,
      pump_a: document.getElementById("pump_a").value,
      pump_b: document.getElementById("pump_b").value,
      pump_c: document.getElementById("pump_c").value,
      pcb: document.getElementById("pcb").value,
    });
  }

  //onSubmit
  const submitData = (e) => {
    e.preventDefault();
    alert("Information has been updated in the database");
    console.log(information);
    console.log("Submitted");

    if (!information.length) {
      console.log(e.target.name + "is empty");
    }

    //post
    const reqPost = {
      method: "POST",
      headers: {
        Authorization: "Token 4ef76b7b1288bbda537123e0fd51a446bd0b0a2f",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(information),
    };
    axiosInstance.get("https://api.cl-ds.com/admin/node/information/", JSON.stringify(information)).then((response) => {
      if (response.status === 200) {
        console.log(response.json());
      } else console.log(response.json());
    });
  };

  return (
    <>
      <span></span>
      <body>
        <div className="col-lg-8 mx-auto">
          <header>
            <h2 className="text-center"> Dashboard/Information </h2>
          </header>

          <Card>
            <Card.Header style={{ backgroundColor: "#7952b3", color: "white" }}> Information </Card.Header>

            <Form style={{ dislay: "flex", padding:"0.8rem" }} onChange={onChangehandler} onSubmit={submitData} required>
              <span></span>
              <Form.Group className="col-12">
                <Form.Label id="serial"> Serial </Form.Label>
                <Form.Control as="select" name="serial" id="serial" className="form-control" defaultValue={selectedValue?.serial} onChange={(e) => setSelected(e.target.value)}>
                  <option value="none" selected disabled hidden>
                    Select an Option
                  </option>
                  {apiValues.mainValues.map(({ serial }) => (
                    <option key={serial} value={serial}>
                      {serial}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>

              <Form.Group className="col-12">
                <Form.Label> Firmware </Form.Label>
                <Form.Control
                  placeholder="Please enter a firmware"
                  type="text"
                  name="firmware"
                  id="firmware"
                  onChange={(e) => onChangehandler(e)}
                  defaultValue={selectedValue?.firmware}
                  key={selectedValue?.firmware}
                ></Form.Control>
              </Form.Group>

              <Form.Group className="col-12">
                <Form.Label> Probe </Form.Label>
                <Form.Control
                  type="text"
                  name="probe"
                  placeholder="Please enter a probe"
                  onChange={(e) => onChangehandler(e)}
                  defaultValue={selectedValue?.probe}
                  key={selectedValue?.probe}
                  id="probe"
                ></Form.Control>
              </Form.Group>

              <Form.Group className="col-12">
                <Form.Label> Pump_A </Form.Label>
                <Form.Control name="pump_a" type="text" placeholder="Please enter Pump A" defaultValue={selectedValue?.pump_a} key={selectedValue?.pump_a} id="pump_a"></Form.Control>
              </Form.Group>

              <Form.Group className="col-12">
                <Form.Label> Pump_B </Form.Label>
                <Form.Control name="pump_b" type="text" placeholder="Please enter Pump B" defaultValue={selectedValue?.pump_b} key={selectedValue?.pump_b} id="pump_b"></Form.Control>
              </Form.Group>

              <Form.Group className="col-12">
                <Form.Label> Pump_C </Form.Label>
                <Form.Control id="pump_c" name="pump_c" type="text" placeholder="Please enter Pump C" defaultValue={selectedValue?.pump_c} key={selectedValue?.pump_c}></Form.Control>
              </Form.Group>

              <Form.Group className="col-12">
                <Form.Label> PCB </Form.Label>
                <Form.Control id="pcb" name="pcb" type="text" placeholder="Please enter PCB" defaultValue={selectedValue?.pcb} key={selectedValue?.pcb}></Form.Control>
              </Form.Group>

              <Form.Group className="col-12 mb-3">
                <Form.Label> Remarks </Form.Label>
                <Form.Control id="remark" name="remark" as="textarea" defaultValue={selectedValue?.remark} key={selectedValue?.remark}></Form.Control>
              </Form.Group>

              <div style={{ textAlign: "center" }}>
                <Button variant="outline-primary" type="submit" onSubmit={submitData}>
                  Submit
                </Button>

                <span> </span>
              </div>
            </Form>
          </Card>
          <div>
            <Button style={{ textAlign: "center" }} type="primary" variant="outline-primary" onClick={openResult}>
              View Data
            </Button>
          </div>
        </div>
      </body>
    </>
  );
};

export default Information;
